module.exports = __webpack_public_path__ + "static/media/AutoCAD User Research.bab134ff.csv";